import { Routes } from '@angular/router';
import { DocumentsPage } from './pages/documents-page/documents-page';
import { DocumentsPreviewPage } from './pages/documents-preview-page/documents-preview-page';
import { videoTutorialsLoadedGuard } from '../tutorials/guards/video-tutorials-loaded.guard';

export const DOCUMENTS_ROUTES: Routes = [
  {
    path: '',
    canActivate: [videoTutorialsLoadedGuard],
    component: DocumentsPage,
  },
  {
    path: ':documentId',
    component: DocumentsPreviewPage,
  },
];

export const COCKPIT_DOCUMENTS_ROUTES = DOCUMENTS_ROUTES;
